import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ac05d22&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {YandexTicketBueButton: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/YandexTicketBueButton/index.vue').default,Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default,TopEntityComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/TopEntityComponent/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
